import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

// Assistente "Gravar Cliente" — a ÚNICA porta de entrada de cliente novo.
// 3 abas: Identificação · Venda · Origem (obrigatória). Ao confirmar:
// cria/reaproveita o cliente, move a oportunidade para GANHO e lança a
// venda no financeiro (parcelada se for o caso).

const token = () => localStorage.getItem('token');

const FORMAS = ['PIX', 'PIX Parcelado', 'Boleto', 'Boleto Parcelado', 'Cartão', 'Dinheiro', 'Transferência'];
const CATEGORIAS = ['Registro de Marca', 'Serviço Jurídico', 'Acessórios de Marcas', 'Diversos'];

// De onde veio a oportunidade — obrigatório antes de gravar (alimenta os
// relatórios de captação). Pré-seleciona quando a própria oportunidade
// entrega a resposta (indicação de parceiro, lançada por SDR).
const ORIGENS = [
  { v: 'Parceiros', icone: '🤝', desc: 'Indicação de contador ou parceiro' },
  { v: 'SDR', icone: '📞', desc: 'Prospecção da equipe SDR' },
  { v: 'Ativo', icone: '🎯', desc: 'Prospecção ativa do closer' },
  { v: 'Cliente', icone: '👥', desc: 'Indicação de quem já é cliente' },
  { v: 'Carteira', icone: '🏠', desc: 'Negócio novo de quem já é cliente (pela ficha)' },
  { v: 'Network', icone: '🌐', desc: 'Rede de contatos, eventos, grupos' },
  { v: 'Rede Social', icone: '📱', desc: 'Instagram, WhatsApp, site…' },
  { v: 'RPI', icone: '📰', desc: 'Captado pela Revista do INPI (prazos, processos sem procurador)' },
];

const inp = { width: '100%', padding: '5px 8px', borderRadius: 4, border: '1px solid #b0b8c4', fontSize: 13, color: '#111', background: '#fff', height: 30, outline: 'none', boxSizing: 'border-box' };
const lbl = { fontSize: 11, fontWeight: 600, color: '#6b7280', display: 'block', marginBottom: 2 };
const btnDoc = { background: '#fff', border: '1px solid #0a1628', color: '#0a1628', borderRadius: 6, padding: '5px 12px', fontSize: 12, fontWeight: 600, cursor: 'pointer' };

function mascaraMoeda(v) {
  const d = String(v).replace(/\D/g, '');
  if (!d) return '';
  return (parseInt(d, 10) / 100).toLocaleString('pt-BR', { minimumFractionDigits: 2 });
}
const moeda = (n) => `R$ ${(Number(n) || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}`;
const valorNumerico = (v) => parseFloat(String(v).replace(/\./g, '').replace(',', '.')) || 0;

export default function ModalGravarCliente({ op, onFechar, onGravado }) {
  const navigate = useNavigate();
  // Oportunidade da CARTEIRA: já nasceu presa a um cadastro (cliente_id). A
  // ficha não se mexe aqui — o assistente abre direto na Venda e a aba
  // Identificação vira só um resumo do cliente.
  const daCarteira = !!op.cliente_id;
  const [aba, setAba] = useState(daCarteira ? 'venda' : 'id');
  const [cli, setCli] = useState({
    nome: op.nome_cliente || '', razao_social: '', telefone: op.telefone || '', email: '',
    cpf: '', cnpj: '', cep: '', rua: '', numero: '', complemento: '', bairro: '', cidade: '', estado: '',
  });
  // Carteira: traz a ficha inteira (procuração/contrato saem com os dados certos)
  useEffect(() => {
    if (!daCarteira) return;
    fetch(`/clientes/${op.cliente_id}`, { headers: { Authorization: `Bearer ${token()}` } })
      .then(r => r.ok ? r.json() : null)
      .then(c => { if (c && c._id) setCli(prev => ({ ...prev, ...c, nome: c.nome || prev.nome, telefone: c.telefone || prev.telefone })); })
      .catch(() => {});
  }, [daCarteira, op.cliente_id]);
  // Origem pré-selecionada: primeiro o que a oportunidade já gravou no
  // nascimento (campo Origem do CRM); senão, o que dá pra deduzir
  const [origem, setOrigem] = useState(
    op.origem_lead || (daCarteira ? 'Carteira' : op.parceiro_id ? 'Parceiros' : (op.criado_por_cargo === 'sdr' ? 'SDR' : ''))
  );
  // Detalhe da origem: QUEM indicou/prospectou — parceiro, cliente ou SDR
  // já cadastrado no sistema. Pré-preenchido quando a oportunidade sabe.
  const [origemDetalhe, setOrigemDetalhe] = useState(
    op.origem_detalhe ? { id: op.origem_detalhe_id || '', nome: op.origem_detalhe }
      : daCarteira ? { id: op.cliente_id, nome: op.cliente_nome || op.nome_cliente || '' }
      : op.parceiro_nome ? { id: op.parceiro_id || '', nome: op.parceiro_nome }
      : (op.criado_por_cargo === 'sdr' && op.sdr ? { id: '', nome: op.sdr } : null)
  );
  const [buscaDet, setBuscaDet] = useState('');
  // Cache das listas por origem (só busca quando o card é escolhido)
  const [listaDet, setListaDet] = useState({});
  useEffect(() => {
    if (!['Parceiros', 'Cliente', 'Carteira', 'SDR'].includes(origem) || listaDet[origem]) return;
    const url = origem === 'Parceiros' ? '/parceiros' : (origem === 'Cliente' || origem === 'Carteira') ? '/clientes' : '/usuarios';
    fetch(url, { headers: { Authorization: `Bearer ${token()}` } })
      .then(r => r.json())
      .then(arr => {
        let itens = Array.isArray(arr) ? arr : [];
        if (origem === 'SDR') itens = itens.filter(u => (u.cargo || '').toLowerCase().includes('sdr'));
        const mapa = itens.map(x => ({
          id: x._id,
          nome: x.nome || x.razao_social || '',
          extra: (origem === 'Cliente' || origem === 'Carteira') ? (x.nome_marca || (x.processos || [])[0]?.nome_marca || x.razao_social || '')
            : origem === 'Parceiros' ? (x.tipo || x.cidade || '') : (x.cargo || ''),
        })).filter(x => x.nome);
        setListaDet(l => ({ ...l, [origem]: mapa }));
      })
      .catch(() => setListaDet(l => ({ ...l, [origem]: [] })));
  }, [origem, listaDet]);
  // Categorias vêm do catálogo de serviços (aba Serviços dos Relatórios);
  // sem catálogo, cai na lista padrão de sempre
  const [categorias, setCategorias] = useState(CATEGORIAS);
  useEffect(() => {
    fetch('/oportunidades/servicos-catalogo', { headers: { Authorization: `Bearer ${token()}` } })
      .then(r => r.json())
      .then(d => {
        const nomes = (d.servicos || []).map(s => s.nome).filter(Boolean);
        if (nomes.length) setCategorias(nomes);
      })
      .catch(() => {});
  }, []);

  // Venda multi-produto: vários itens no histórico, UM só contas a receber
  const [venda, setVenda] = useState({
    itens: [{ servico: '', categoria: 'Registro de Marca', quantidade: 1, valor: '' }],
    forma_pagamento: '', num_parcelas: 1, data_primeira: '',
  });
  const setItem = (i, patch) => setVenda(v => ({ ...v, itens: v.itens.map((it, k) => k === i ? { ...it, ...patch } : it) }));
  const addItem = () => setVenda(v => ({ ...v, itens: [...v.itens, { servico: '', categoria: 'Registro de Marca', quantidade: 1, valor: '' }] }));
  const rmItem = (i) => setVenda(v => ({ ...v, itens: v.itens.filter((_, k) => k !== i) }));
  // Valor do item é UNITÁRIO: total da linha = quantidade × valor
  const totalVenda = venda.itens.reduce((s, it) => s + Math.max(1, parseInt(it.quantidade, 10) || 1) * valorNumerico(it.valor), 0);
  const resumoServicos = venda.itens.map(it => (Number(it.quantidade) > 1 ? `${it.quantidade}× ` : '') + (it.servico || '').trim()).filter(s => s.trim()).join(' + ');
  const [confirmando, setConfirmando] = useState(false);
  const [gravando, setGravando] = useState(false);
  const [resultado, setResultado] = useState(null);
  const [buscandoCep, setBuscandoCep] = useState(false);
  const [buscandoCnpj, setBuscandoCnpj] = useState(false);
  const [erroBusca, setErroBusca] = useState('');
  const [erroGravar, setErroGravar] = useState('');

  const setC = (k) => (e) => setCli(f => ({ ...f, [k]: e.target.value }));
  const ehParcelada = /parcelad/i.test(venda.forma_pagamento);

  async function buscarCep() {
    const c = (cli.cep || '').replace(/\D/g, '');
    if (c.length !== 8) return setErroBusca('CEP deve ter 8 dígitos.');
    setErroBusca(''); setBuscandoCep(true);
    try {
      const d = await (await fetch(`https://viacep.com.br/ws/${c}/json/`)).json();
      if (d.erro) setErroBusca('CEP não encontrado.');
      else setCli(p => ({ ...p, rua: d.logradouro || p.rua, bairro: d.bairro || p.bairro, cidade: d.localidade || p.cidade, estado: d.uf || p.estado }));
    } catch { setErroBusca('Erro ao consultar o CEP.'); }
    setBuscandoCep(false);
  }

  async function buscarCnpj() {
    const c = (cli.cnpj || '').replace(/\D/g, '');
    if (c.length !== 14) return setErroBusca('CNPJ deve ter 14 dígitos.');
    setErroBusca(''); setBuscandoCnpj(true);
    try {
      const res = await fetch(`/clientes/consultar-cnpj/${c}`, { headers: { Authorization: `Bearer ${token()}` } });
      if (!res.ok) { const e = await res.json(); setErroBusca(e.erro || 'CNPJ não encontrado.'); }
      else {
        const d = await res.json();
        setCli(p => ({
          ...p,
          razao_social: d.razao_social || p.razao_social,
          nome: p.nome || d.nome_fantasia || '',
          email: d.email || p.email,
          telefone: p.telefone || (d.telefone ? d.telefone.replace(/\D/g, '').replace(/^(\d{2})(\d+)/, '($1) $2') : ''),
          cep: d.cep || p.cep, rua: d.rua || p.rua, numero: d.numero || p.numero,
          complemento: d.complemento || p.complemento, bairro: d.bairro || p.bairro,
          cidade: d.cidade || p.cidade, estado: d.estado || p.estado,
        }));
      }
    } catch { setErroBusca('Erro ao consultar a Receita Federal.'); }
    setBuscandoCnpj(false);
  }

  async function gravar() {
    setGravando(true); setErroGravar('');
    try {
      const res = await fetch(`/oportunidades/${op._id}/gravar-cliente`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token()}` },
        body: JSON.stringify({
          cliente: cli,
          origem_lead: origem,
          origem_detalhe: origemDetalhe?.nome || '',
          origem_detalhe_id: origemDetalhe?.id || '',
          // itens vão pro histórico (uma venda por produto); os campos
          // derivados mantêm o snapshot legível e a compatibilidade
          venda: {
            ...venda,
            num_parcelas: ehParcelada ? venda.num_parcelas : 1,
            servico: resumoServicos,
            categoria: venda.itens[0]?.categoria || 'Registro de Marca',
            quantidade: venda.itens.reduce((s, it) => s + (parseInt(it.quantidade) || 1), 0),
            valor: totalVenda.toFixed(2).replace('.', ','),
          },
        }),
      });
      const j = await res.json();
      if (!res.ok || !j.ok) throw new Error(j.erro || 'Falha ao gravar');
      setResultado(j);
    } catch (e) { setErroGravar(e.message); setConfirmando(false); }
    setGravando(false);
  }

  const ABAS = [
    { k: 'id', l: '1. Identificação' },
    { k: 'venda', l: '2. Venda *' },
    { k: 'origem', l: '3. Origem' },
  ];
  const idxAba = ABAS.findIndex(a => a.k === aba);

  // ── Tela de sucesso ──
  if (resultado) {
    return (
      <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.55)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 2000, padding: 16 }}>
        <div style={{ background: '#fff', borderRadius: 10, width: '100%', maxWidth: 420, overflow: 'hidden', boxShadow: '0 20px 60px rgba(0,0,0,0.3)' }}>
          <div style={{ background: '#16a34a', padding: '14px 18px', color: '#fff', fontSize: 15, fontWeight: 700 }}>🎉 Cliente gravado!</div>
          <div style={{ padding: 18 }}>
            <p style={{ fontSize: 14, color: '#374151', margin: '0 0 6px' }}><strong>{cli.nome || cli.razao_social}</strong> {daCarteira ? 'já é cliente — venda lançada na ficha'
              : resultado.reaproveitado && !resultado.ficha_atualizada ? 'já era cliente — venda lançada na ficha existente'
              : resultado.reaproveitado ? 'atualizado (já existia — dados unificados)' : 'cadastrado'} e oportunidade movida para <strong style={{ color: '#16a34a' }}>Ganho</strong>.</p>
            <ul style={{ fontSize: 13, color: '#6b7280', margin: '0 0 16px', paddingLeft: 18 }}>
              {resultado.parcelas > 0 && <li>{resultado.parcelas} lançamento(s) a receber criados no Financeiro</li>}
              {origem && <li>Origem registrada: <strong>{origem}</strong></li>}
            </ul>
            <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end' }}>
              <button onClick={onGravado} style={{ background: '#f3f4f6', color: '#374151', border: '1px solid #d1d5db', padding: '8px 18px', borderRadius: 6, fontSize: 13, cursor: 'pointer', fontWeight: 600 }}>Fechar</button>
              <button onClick={() => { navigate(`/clientes/${resultado.cliente_id}/editar`); onGravado(); }} style={{ background: '#0a1628', color: '#fff', border: 'none', padding: '8px 18px', borderRadius: 6, fontSize: 13, cursor: 'pointer', fontWeight: 700 }}>Abrir cadastro</button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.55)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 2000, padding: 16 }} onClick={onFechar}>
      <div onClick={e => e.stopPropagation()} style={{ background: '#fff', borderRadius: 10, width: '100%', maxWidth: 640, maxHeight: '92vh', display: 'flex', flexDirection: 'column', boxShadow: '0 20px 60px rgba(0,0,0,0.3)', position: 'relative' }}>
        {/* Cabeçalho */}
        <div style={{ background: '#0a1628', padding: '10px 16px', borderRadius: '10px 10px 0 0', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div>
            <div style={{ color: '#fff', fontSize: 14, fontWeight: 700 }}>💾 Gravar Cliente</div>
            <div style={{ color: '#94a3b8', fontSize: 11 }}>{op.nome_cliente} · a oportunidade irá para GANHO ao gravar</div>
          </div>
          <button onClick={onFechar} style={{ background: 'none', border: 'none', color: '#94a3b8', fontSize: 20, cursor: 'pointer', lineHeight: 1 }}>×</button>
        </div>

        {/* Abas */}
        <div style={{ display: 'flex', borderBottom: '2px solid #0a1628' }}>
          {ABAS.map(t => (
            <button key={t.k} onClick={() => setAba(t.k)} style={{
              flex: 1, padding: '7px 4px', fontSize: 12, fontWeight: 600, border: 'none', cursor: 'pointer',
              color: aba === t.k ? '#fff' : '#374151', background: aba === t.k ? '#0a1628' : '#eef1f5',
            }}>{t.l}</button>
          ))}
        </div>

        {/* Conteúdo */}
        <div style={{ padding: 16, overflowY: 'auto', flex: 1 }}>
          {aba === 'id' && daCarteira && (
            <div style={{ border: '1px solid #99f6e4', background: '#f0fdfa', borderRadius: 8, padding: 14 }}>
              <div style={{ fontSize: 12, fontWeight: 700, color: '#0f766e', marginBottom: 6 }}>🏠 Cliente da carteira — a ficha não é alterada aqui</div>
              <div style={{ fontSize: 14, fontWeight: 700, color: '#0a1628' }}>{cli.nome || op.cliente_nome || op.nome_cliente}</div>
              <div style={{ fontSize: 12.5, color: '#374151', marginTop: 2 }}>
                {[cli.razao_social, cli.cnpj || cli.cpf, cli.telefone, cli.email].filter(Boolean).join(' · ') || 'Carregando dados do cadastro…'}
              </div>
              <div style={{ fontSize: 12, color: '#6b7280', marginTop: 8 }}>
                Esta oportunidade nasceu na ficha do cliente. Ao confirmar, só a venda entra: parcelas no contas a receber e registro no relatório, no cadastro que já existe.
              </div>
              <button type="button" onClick={() => navigate(`/clientes/${op.cliente_id}/editar`)} style={{ ...btnDoc, marginTop: 10 }}>📇 Abrir cadastro</button>
            </div>
          )}
          {aba === 'id' && !daCarteira && (
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 10 }}>
              <div style={{ flex: '2 1 200px' }}><label style={lbl}>Nome *</label><input value={cli.nome} onChange={setC('nome')} style={inp} /></div>
              <div style={{ flex: '1 1 140px' }}><label style={lbl}>Telefone</label><input value={cli.telefone} onChange={setC('telefone')} style={inp} /></div>
              <div style={{ flex: '1 1 160px' }}><label style={lbl}>E-mail</label><input value={cli.email} onChange={setC('email')} style={inp} /></div>
              <div style={{ flex: '1 1 130px' }}><label style={lbl}>CPF</label><input value={cli.cpf} onChange={setC('cpf')} style={inp} /></div>
              <div style={{ flex: '2 1 220px' }}>
                <label style={lbl}>CNPJ</label>
                <div style={{ display: 'flex', gap: 6 }}>
                  <input value={cli.cnpj} onChange={setC('cnpj')} placeholder="00.000.000/0000-00" style={{ ...inp, flex: 1 }} />
                  <button onClick={buscarCnpj} disabled={buscandoCnpj} style={{ ...btnDoc, whiteSpace: 'nowrap' }}>{buscandoCnpj ? '...' : '🔍 Consultar CNPJ'}</button>
                </div>
              </div>
              <div style={{ flex: '2 1 240px' }}><label style={lbl}>Razão Social</label><input value={cli.razao_social} onChange={setC('razao_social')} style={inp} /></div>
              <div style={{ flex: '1 1 150px' }}>
                <label style={lbl}>CEP</label>
                <div style={{ display: 'flex', gap: 6 }}>
                  <input value={cli.cep} onChange={setC('cep')} placeholder="00000-000" style={{ ...inp, flex: 1 }} />
                  <button onClick={buscarCep} disabled={buscandoCep} style={btnDoc}>{buscandoCep ? '...' : '🔍'}</button>
                </div>
              </div>
              <div style={{ flex: '3 1 240px' }}><label style={lbl}>Rua</label><input value={cli.rua} onChange={setC('rua')} style={inp} /></div>
              <div style={{ flex: '0 1 80px' }}><label style={lbl}>Número</label><input value={cli.numero} onChange={setC('numero')} style={inp} /></div>
              <div style={{ flex: '1 1 130px' }}><label style={lbl}>Complemento</label><input value={cli.complemento} onChange={setC('complemento')} style={inp} /></div>
              <div style={{ flex: '1 1 140px' }}><label style={lbl}>Bairro</label><input value={cli.bairro} onChange={setC('bairro')} style={inp} /></div>
              <div style={{ flex: '1 1 140px' }}><label style={lbl}>Cidade</label><input value={cli.cidade} onChange={setC('cidade')} style={inp} /></div>
              <div style={{ flex: '0 1 60px' }}><label style={lbl}>UF</label><input value={cli.estado} onChange={setC('estado')} style={inp} /></div>
              {erroBusca && <div style={{ width: '100%', color: '#dc2626', fontSize: 12 }}>{erroBusca}</div>}
            </div>
          )}

          {aba === 'origem' && (
            <div>
              <div style={{ fontSize: 12.5, color: '#374151', marginBottom: 10 }}>
                De onde veio essa oportunidade? <strong style={{ color: '#dc2626' }}>Obrigatório</strong> — alimenta os relatórios de captação.
              </div>
              {daCarteira && (
                <div style={{ border: '1px solid #99f6e4', background: '#f0fdfa', borderRadius: 8, padding: '10px 12px', fontSize: 12.5, color: '#0f766e', marginBottom: 8 }}>
                  🏠 <strong>Carteira</strong> — negócio novo de quem já é cliente ({origemDetalhe?.nome || op.cliente_nome}). A origem já vem definida pela ficha.
                </div>
              )}
              {!daCarteira && (
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(180px, 1fr))', gap: 8 }}>
                {ORIGENS.map(o => {
                  const sel = origem === o.v;
                  return (
                    <button key={o.v} onClick={() => { if (origem !== o.v) { setOrigem(o.v); setOrigemDetalhe(null); setBuscaDet(''); } }} style={{
                      display: 'flex', alignItems: 'center', gap: 10, padding: '10px 12px', borderRadius: 8, cursor: 'pointer', textAlign: 'left',
                      border: `2px solid ${sel ? '#16a34a' : '#dbe2ea'}`, background: sel ? '#f0fdf4' : '#fff',
                    }}>
                      <span style={{ fontSize: 20 }}>{o.icone}</span>
                      <span>
                        <span style={{ display: 'block', fontSize: 13, fontWeight: 700, color: sel ? '#15803d' : '#0a1628' }}>{o.v}{sel ? ' ✓' : ''}</span>
                        <span style={{ display: 'block', fontSize: 10.5, color: '#6b7280' }}>{o.desc}</span>
                      </span>
                    </button>
                  );
                })}
              </div>
              )}
              {!daCarteira && ['Parceiros', 'Cliente', 'SDR'].includes(origem) && (() => {
                const rotulo = origem === 'Parceiros' ? '🤝 Qual parceiro indicou?'
                  : origem === 'Cliente' ? '👥 Qual cliente indicou?' : '📞 Qual SDR prospectou?';
                const sem = (s) => String(s || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase();
                const lista = listaDet[origem];
                const opcoes = (lista || []).filter(x => !buscaDet.trim() || sem(x.nome + ' ' + x.extra).includes(sem(buscaDet)));
                return (
                  <div style={{ marginTop: 14, background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: 8, padding: '10px 12px' }}>
                    <label style={{ ...lbl, fontSize: 12 }}>{rotulo}</label>
                    {origemDetalhe ? (
                      <div style={{ display: 'inline-flex', alignItems: 'center', gap: 8, background: '#f0fdf4', border: '1px solid #bbf7d0', borderRadius: 20, padding: '5px 14px' }}>
                        <span style={{ fontSize: 13, fontWeight: 700, color: '#15803d' }}>✓ {origemDetalhe.nome}</span>
                        <button onClick={() => { setOrigemDetalhe(null); setBuscaDet(''); }} title="Trocar"
                          style={{ background: 'none', border: 'none', color: '#6b7280', fontSize: 14, cursor: 'pointer', padding: 0, lineHeight: 1 }}>✕</button>
                      </div>
                    ) : lista === undefined ? (
                      <div style={{ fontSize: 12, color: '#6b7280' }}>Carregando cadastros…</div>
                    ) : lista.length === 0 ? (
                      <div style={{ fontSize: 12, color: '#9ca3af' }}>Nenhum cadastro encontrado no sistema.</div>
                    ) : (
                      <>
                        <input value={buscaDet} onChange={e => setBuscaDet(e.target.value)} autoFocus
                          placeholder={`🔎 Digite pra buscar entre ${lista.length} cadastrado(s)…`}
                          style={{ ...inp, marginBottom: 6 }} />
                        <div style={{ maxHeight: 168, overflowY: 'auto', border: '1px solid #e5e7eb', borderRadius: 6, background: '#fff' }}>
                          {opcoes.slice(0, 30).map(x => (
                            <div key={x.id} onClick={() => setOrigemDetalhe({ id: x.id, nome: x.nome })}
                              style={{ display: 'flex', justifyContent: 'space-between', gap: 8, padding: '6px 10px', fontSize: 12.5, cursor: 'pointer', borderBottom: '1px solid #f3f4f6' }}
                              onMouseEnter={e => e.currentTarget.style.background = '#f0fdf4'}
                              onMouseLeave={e => e.currentTarget.style.background = '#fff'}>
                              <span style={{ fontWeight: 600, color: '#0a1628', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{x.nome}</span>
                              {x.extra && <span style={{ color: '#9ca3af', fontSize: 11, flexShrink: 0 }}>{x.extra}</span>}
                            </div>
                          ))}
                          {opcoes.length === 0 && <div style={{ padding: 10, fontSize: 12, color: '#9ca3af', textAlign: 'center' }}>Ninguém com esse nome.</div>}
                          {opcoes.length > 30 && <div style={{ padding: '4px 10px', fontSize: 10.5, color: '#9ca3af' }}>mostrando 30 de {opcoes.length} — digite pra refinar</div>}
                        </div>
                      </>
                    )}
                  </div>
                );
              })()}
              {(op.parceiro_nome || op.criado_por_cargo === 'sdr') && (
                <div style={{ marginTop: 10, fontSize: 11.5, color: '#6b7280' }}>
                  💡 Pré-selecionado porque a oportunidade {op.parceiro_nome ? <>veio do parceiro <strong>{op.parceiro_nome}</strong></> : 'foi lançada por SDR'} — pode trocar se não for o caso.
                </div>
              )}
            </div>
          )}

          {aba === 'venda' && (
            <div>
              {/* Produtos da venda: cada um vira um registro no histórico */}
              {venda.itens.map((it, i) => (
                <div key={i} style={{ display: 'flex', flexWrap: 'wrap', gap: 10, alignItems: 'flex-end', padding: venda.itens.length > 1 ? '8px 10px' : 0, border: venda.itens.length > 1 ? '1px solid #e2e8f0' : 'none', borderRadius: 6, marginBottom: 8, background: venda.itens.length > 1 ? '#fafbfc' : 'transparent' }}>
                  {/* Serviço = catálogo (aba Serviços dos Relatórios); a categoria
                      recebe o mesmo valor por baixo — relatórios seguem agrupando */}
                  <div style={{ flex: '2 1 220px' }}>
                    <label style={lbl}>{venda.itens.length > 1 ? `Produto ${i + 1} *` : 'Serviço vendido *'}</label>
                    <select value={it.servico} onChange={e => setItem(i, { servico: e.target.value, categoria: e.target.value })} style={inp}>
                      <option value="">— selecione o serviço —</option>
                      {categorias.map(c => <option key={c} value={c}>{c}</option>)}
                    </select>
                  </div>
                  <div style={{ flex: '0 1 70px' }}><label style={lbl} title="Quantos itens desse produto">Qtd</label>
                    <select value={it.quantidade} onChange={e => setItem(i, { quantidade: e.target.value })} style={inp}>
                      {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map(n => <option key={n} value={n}>{n}</option>)}
                    </select>
                  </div>
                  <div style={{ flex: '1 1 120px' }}><label style={lbl}>Valor unitário (R$)</label><input value={it.valor} onChange={e => setItem(i, { valor: mascaraMoeda(e.target.value) })} inputMode="numeric" placeholder="0,00" style={inp} /></div>
                  {parseInt(it.quantidade, 10) > 1 && valorNumerico(it.valor) > 0 && (
                    <div style={{ fontSize: 11.5, color: '#0a1628', fontWeight: 600, alignSelf: 'flex-end', paddingBottom: 7 }}>= {moeda(parseInt(it.quantidade, 10) * valorNumerico(it.valor))}</div>
                  )}
                  {venda.itens.length > 1 && (
                    <button onClick={() => rmItem(i)} title="Remover este produto" style={{ background: 'none', border: 'none', color: '#dc2626', fontSize: 15, cursor: 'pointer', padding: '4px 6px' }}>✕</button>
                  )}
                </div>
              ))}
              <button onClick={addItem} style={{ background: '#fff', color: '#0369a1', border: '1px dashed #7dd3fc', borderRadius: 6, padding: '5px 12px', fontSize: 12, fontWeight: 700, cursor: 'pointer', marginBottom: 12 }}>
                ➕ Adicionar outro produto
              </button>

              {/* Pagamento: UM só contas a receber pro total, independente de quantos produtos */}
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: 10 }}>
                <div style={{ flex: '1 1 150px' }}>
                  <label style={lbl}>Forma de pagamento</label>
                  <select value={venda.forma_pagamento} onChange={e => setVenda(v => ({ ...v, forma_pagamento: e.target.value }))} style={inp}>
                    <option value="">— selecione —</option>
                    {FORMAS.map(f => <option key={f} value={f}>{f}</option>)}
                  </select>
                </div>
                <div style={{ flex: '1 1 150px' }}><label style={lbl}>{ehParcelada ? '1º vencimento' : 'Vencimento'}</label><input type="date" value={venda.data_primeira} onChange={e => setVenda(v => ({ ...v, data_primeira: e.target.value }))} style={inp} /></div>
                {ehParcelada && (
                  <div style={{ width: '100%', background: '#f5f7fa', border: '1px solid #e2e8f0', borderRadius: 6, padding: '8px 10px', display: 'flex', gap: 10, alignItems: 'center', flexWrap: 'wrap' }}>
                    <span style={{ fontSize: 12, fontWeight: 600, color: '#374151' }}>Nº de parcelas:</span>
                    <select value={venda.num_parcelas} onChange={e => setVenda(v => ({ ...v, num_parcelas: e.target.value }))} style={{ ...inp, width: 90 }}>
                      {Array.from({ length: 24 }, (_, k) => k + 1).map(n => <option key={n} value={n}>{n}x</option>)}
                    </select>
                    {Number(venda.num_parcelas) > 1 && totalVenda > 0 && (
                      <span style={{ fontSize: 12, color: '#6b7280' }}>{venda.num_parcelas}x de {moeda(totalVenda / Number(venda.num_parcelas))} · lançadas mês a mês no Financeiro</span>
                    )}
                  </div>
                )}
                {totalVenda > 0 && (
                  <div style={{ width: '100%', fontSize: 12, color: '#15803d', fontWeight: 600 }}>
                    {venda.itens.length > 1 ? `${venda.itens.length} produtos no histórico · ` : ''}
                    Será lançado UM a receber: {ehParcelada && Number(venda.num_parcelas) > 1 ? `${venda.num_parcelas} parcelas · total ` : ''}{moeda(totalVenda)}
                  </div>
                )}
              </div>
            </div>
          )}

        </div>

        {/* Rodapé */}
        {erroGravar && <div style={{ padding: '0 16px', color: '#dc2626', fontSize: 12 }}>⚠️ {erroGravar}</div>}
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px 16px', borderTop: '1px solid #e5e7eb' }}>
          <button onClick={onFechar} style={{ background: 'none', border: 'none', color: '#6b7280', fontSize: 12, cursor: 'pointer' }}>Cancelar</button>
          <div style={{ display: 'flex', gap: 8 }}>
            {idxAba > 0 && <button onClick={() => setAba(ABAS[idxAba - 1].k)} style={{ background: '#fff', border: '1px solid #d1d5db', borderRadius: 6, padding: '7px 14px', fontSize: 12, fontWeight: 600, color: '#374151', cursor: 'pointer' }}>← Voltar</button>}
            {idxAba < ABAS.length - 1 && <button onClick={() => setAba(ABAS[idxAba + 1].k)} style={{ background: '#0a1628', color: '#fff', border: 'none', borderRadius: 6, padding: '7px 14px', fontSize: 12, fontWeight: 600, cursor: 'pointer' }}>Avançar →</button>}
            <button onClick={() => {
              if (!(cli.nome || '').trim() && !(cli.razao_social || '').trim()) return alert('Informe o nome do cliente (aba 1).');
              // Venda obrigatória (17/09): cliente novo não entra sem serviço, valor,
              // forma de pagamento e vencimento. O servidor confere de novo.
              if (!venda.itens.length || venda.itens.some(it => !(it.servico || '').trim() || valorNumerico(it.valor) <= 0)) {
                setAba('venda'); return alert('Informe o serviço e o valor de cada produto (aba 2 — Venda). Cliente novo não entra sem venda.');
              }
              if (!venda.forma_pagamento) { setAba('venda'); return alert('Informe a forma de pagamento (aba 2 — Venda).'); }
              if (!venda.data_primeira) { setAba('venda'); return alert(`Informe o ${ehParcelada ? '1º vencimento' : 'vencimento'} (aba 2 — Venda).`); }
              if (!origem) { setAba('origem'); return alert('Informe a origem da oportunidade (aba 3) — é obrigatório.'); }
              setConfirmando(true);
            }}
              style={{ background: '#16a34a', color: '#fff', border: 'none', borderRadius: 6, padding: '7px 16px', fontSize: 12, fontWeight: 700, cursor: 'pointer' }}>
              💾 Gravar Cliente
            </button>
          </div>
        </div>

        {/* Confirmação final */}
        {confirmando && (
          <div style={{ position: 'absolute', inset: 0, background: 'rgba(10,22,40,0.55)', display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: 10 }}>
            <div style={{ background: '#fff', borderRadius: 10, padding: 20, width: 360, maxWidth: '90%', boxShadow: '0 12px 40px rgba(0,0,0,0.3)' }}>
              <div style={{ fontSize: 15, fontWeight: 700, color: '#0a1628', marginBottom: 8 }}>Confirmar gravação?</div>
              <p style={{ fontSize: 13, color: '#374151', margin: '0 0 6px' }}>Deseja realmente gravar o cliente <strong>{cli.nome || cli.razao_social}</strong>?</p>
              <ul style={{ fontSize: 12, color: '#6b7280', margin: '0 0 16px', paddingLeft: 18 }}>
                <li>A oportunidade vai para a coluna <strong>Ganho</strong></li>
                <li>Origem: <strong>{origem}</strong></li>
                {totalVenda > 0 && <li>Venda de {moeda(totalVenda)}{venda.itens.length > 1 ? ` (${venda.itens.length} produtos)` : ''}{ehParcelada && Number(venda.num_parcelas) > 1 ? ` em ${venda.num_parcelas}x` : ''} lançada no Financeiro (um só a receber)</li>}
              </ul>
              <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
                <button onClick={() => setConfirmando(false)} disabled={gravando} style={{ background: '#fff', border: '1px solid #d1d5db', borderRadius: 6, padding: '7px 14px', fontSize: 12, fontWeight: 600, color: '#374151', cursor: 'pointer' }}>Voltar</button>
                <button onClick={gravar} disabled={gravando} style={{ background: '#16a34a', color: '#fff', border: 'none', borderRadius: 6, padding: '7px 16px', fontSize: 12, fontWeight: 700, cursor: 'pointer', opacity: gravando ? 0.6 : 1 }}>{gravando ? 'Gravando...' : 'Sim, gravar cliente'}</button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
